<template lang="pug">
v-container
  div.text-md.font-medium.basic700--text {{ $t('manual_payment') }}
  v-row(no-gutters)
    v-col(cols="12" sm="6")
      //- v-card.round-xl.pa-4.mt-6(outlined)
        v-row(no-gutters align="center")
          v-col
            div.text-md.font-semibold.neutral700--text {{ $t('bank_transfer') }}
            div.text-md.neutral700--text {{ $t('bank_transfer_desc') }}
          v-col.shrink
            yc-checkbox
      v-card.round-xl.pa-4.mt-4(outlined)
        v-row(no-gutters align="center")
          v-col
            div.text-md.font-semibold.neutral700--text {{ $t('pay_at_counter') }}
            div.text-md.neutral700--text {{ $t('pay_at_counter_desc') }}
          v-col.shrink
            yc-checkbox(v-model="payAtCounter")
      //- v-card.round-xl.pa-4.mt-4(outlined)
        v-row(no-gutters align="center")
          v-col
            div.text-md.font-semibold.neutral700--text {{ $t('qr_pay') }}
            div.text-md.neutral700--text {{ $t('qr_pay_desc') }}
          v-col.shrink
            yc-checkbox


  div.d-flex.mt-5
    v-spacer
    v-btn.button-md(color="neutral700" dark depressed :loading="isLoading" @click="saveData") {{ $t('save') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import EmbedDialog from '@/components/donation/dialogs/EmbedDialog.vue'

export default {
  name: 'GeneralManualPayment',
  components: { EmbedDialog },
  data () {
    return {
      isLoading: false,
      languageSelection: null,
      payAtCounter: false
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      form: 'clinic/getForm'
    }),
  },
  mounted () {
    this.setData()
  },
  methods: {
    ...mapActions(['showMessage']),
    setData () {
      this.payAtCounter = !this.form.pay_now
    },
    saveData () {
      this.isLoading = true
      const data = {
        pay_now: !this.payAtCounter
      }
      this.$axios.patch(`/forms/${this.form.id}`, data)
        .then(() => {
          const form = { ...this.form, pay_now: !this.payAtCounter }
          this.$store.commit('clinic/setForm', form)
          this.showMessage(['success', this.$t('success_message.successfully_updated')])
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }

}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-basic500);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>